(() => {
  const CONTAINER_SELECTOR = ".sealsubs-container";
  const OPTION_NAME_SELECTOR =
    ".sls-option-container[data-selling-plan-group] .sls-selling-plan-group-name";
  const NATIVE_POPUP_SELECTOR = ".sls-more-info-popup";
  const TRIGGER_CLASS = "corridge-subscription-info-trigger";
  const CLOSE_CLASS = "corridge-subscription-info-close";
  const POPUP_CLASS = "corridge-subscription-info-popup";
  const BACKDROP_CLASS = "corridge-subscription-info-backdrop";
  const OPEN_CLASS = "corridge-is-open";

  let frameId = null;

  function enhanceContainer(container) {
    container
      .querySelectorAll(
        `.sls-option-container:not([data-selling-plan-group]) .${TRIGGER_CLASS}`,
      )
      .forEach((trigger) => trigger.remove());

    const nativePopup =
      container.corridgeSubscriptionPopup ||
      container.querySelector(NATIVE_POPUP_SELECTOR);
    const optionNames = container.querySelectorAll(OPTION_NAME_SELECTOR);

    if (!nativePopup || !optionNames.length) return;

    container.corridgeSubscriptionPopup = nativePopup;
    nativePopup.classList.add(POPUP_CLASS);

    let backdrop = nativePopup.corridgeBackdrop;
    if (!backdrop) {
      backdrop = document.createElement("div");
      backdrop.className = BACKDROP_CLASS;
      backdrop.setAttribute("aria-hidden", "true");
      nativePopup.corridgeBackdrop = backdrop;
      document.body.append(backdrop, nativePopup);
    }

    nativePopup.setAttribute("role", "dialog");
    nativePopup.setAttribute("aria-label", "Sparplan-Bedingungen");
    if (!nativePopup.classList.contains(OPEN_CLASS)) {
      nativePopup.setAttribute("aria-hidden", "true");
    }
    const closePopup = () => {
      nativePopup.classList.remove(OPEN_CLASS);
      backdrop.classList.remove(OPEN_CLASS);
      nativePopup.setAttribute("aria-hidden", "true");
      nativePopup.corridgeReturnFocus?.focus();
      nativePopup.corridgeReturnFocus = null;
    };

    let closeButton = nativePopup.querySelector(`.${CLOSE_CLASS}`);

    if (!closeButton) {
      closeButton = document.createElement("button");
      closeButton.type = "button";
      closeButton.className = CLOSE_CLASS;
      closeButton.setAttribute("aria-label", "Sparplan-Bedingungen schließen");
      closeButton.innerHTML = '<span aria-hidden="true"></span>';
      closeButton.addEventListener("click", closePopup);
      nativePopup.prepend(closeButton);
    }

    optionNames.forEach((optionName) => {
      if (optionName.querySelector(`.${TRIGGER_CLASS}`)) return;

      const trigger = document.createElement("button");
      trigger.type = "button";
      trigger.className = TRIGGER_CLASS;
      trigger.setAttribute("aria-label", "Sparplan-Bedingungen anzeigen");
      trigger.setAttribute("aria-haspopup", "dialog");
      trigger.innerHTML = '<span aria-hidden="true">?</span>';

      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        nativePopup.corridgeReturnFocus = trigger;
        backdrop.classList.add(OPEN_CLASS);
        nativePopup.classList.add(OPEN_CLASS);
        nativePopup.setAttribute("aria-hidden", "false");
        closeButton.focus();
      });

      optionName.append(trigger);
    });
  }

  function enhance() {
    frameId = null;
    document.querySelectorAll(CONTAINER_SELECTOR).forEach(enhanceContainer);
  }

  function scheduleEnhance() {
    if (frameId !== null) return;
    frameId = window.requestAnimationFrame(enhance);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleEnhance, { once: true });
  } else {
    scheduleEnhance();
  }

  new MutationObserver(scheduleEnhance).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document
      .querySelectorAll(`${NATIVE_POPUP_SELECTOR}.${OPEN_CLASS}`)
      .forEach((popup) => {
        popup.classList.remove(OPEN_CLASS);
        popup.corridgeBackdrop?.classList.remove(OPEN_CLASS);
        popup.setAttribute("aria-hidden", "true");
        popup.corridgeReturnFocus?.focus();
        popup.corridgeReturnFocus = null;
      });
  });

  document.addEventListener("click", (event) => {
    document
      .querySelectorAll(`${NATIVE_POPUP_SELECTOR}.${OPEN_CLASS}`)
      .forEach((popup) => {
        if (popup.contains(event.target)) return;
        popup.classList.remove(OPEN_CLASS);
        popup.corridgeBackdrop?.classList.remove(OPEN_CLASS);
        popup.setAttribute("aria-hidden", "true");
        popup.corridgeReturnFocus?.focus();
        popup.corridgeReturnFocus = null;
      });
  });

  document.addEventListener("shopify:section:load", scheduleEnhance);
})();
